<!--
 * @Descripttion: 
 * @Author: liaoyijun
 * @Date: 2021-08-18 13:56:41
 * @LastEditors: liaoyijun
 * @LastEditTime: 2021-08-18 14:43:42
-->
<template>
    <developStyle></developStyle>
</template>

<script>
import developStyle from "@/components/developing-style";
export default {
    components: {
        developStyle,
    },
};
</script>

<style scoped></style>
